<input
  type="text"
  [ngModel]="filterValue"
  (ngModelChange)="updateSelection($event)"
  [matAutocomplete]="auto"
  autocomplete="off"
  [placeholder]="placeholder"
  [disabled]="disabled"
  (focus)="selectText($event)"
  />

  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="formatInputValue.bind(this)"
    (optionSelected)="emitSelectedOption($event)"
    >
    @for (item of filteredCandidates; track item) {
      <mat-option [value]="item.value">{{ item.formatted }}</mat-option>
    }
  </mat-autocomplete>
